import { render, staticRenderFns } from "./DashboardActions.vue?vue&type=template&id=08bc7d7f&scoped=true"
import script from "./DashboardActions.vue?vue&type=script&lang=js"
export * from "./DashboardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc7d7f",
  null
  
)

export default component.exports